module.exports = __webpack_public_path__ + "assets/apple-icloud-mail.b3c8635a.svg";